import { attachLoadingSpinner } from './utilities/loading-spinner';

(function () {
  'use strict';

  const exports = {

    initializeEventFilter: function () {
      const eventFilterForm = document.getElementById('event-filter');
      const checkboxes = eventFilterForm.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function () {
          exports.submitFilterForm();
        });
      });
    },

    submitFilterForm: function() {
      const eventFilterForm = document.getElementById('event-filter');
      const currentEventList = document.querySelector('.js-filtered-list');
      currentEventList.textContent = '';
      currentEventList.insertAdjacentElement('afterbegin', attachLoadingSpinner(''));
      eventFilterForm.submit();
    }

  };

  exports.initializeEventFilter();

})();
